import { get as getProjection, transform  } from "ol/proj";

export const crsTransformation = (sourceCrs, targetCrs, feature) => {
  const geometry = feature.geometry;
    let transformedCoordinates;
    const sourceProjection = getProjection(sourceCrs);
    
    // CHECK WEATHER THE SOURCE PROJECTION IS VALID
    if (!sourceProjection) {
      console.error(`Invalid projection: sourceCrs=${sourceCrs}`);
      return feature;
    }
    const targetProjection = getProjection(targetCrs);
    if (!targetProjection) {
      console.error(`Invalid projection: targetCrs=${targetCrs}`);
      return feature;

    }
    switch (geometry.type) {
      case 'Point':
        transformedCoordinates = (() => {
          try { return transform(geometry.coordinates, sourceCrs, targetCrs); }
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })();
        break;
      case 'MultiPoint':
        transformedCoordinates = (() => {
          try {  return geometry.coordinates.map(point => transform(point, sourceCrs, targetCrs)) }
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })()
      case 'LineString':
        transformedCoordinates = (() => {
          try { return geometry.coordinates.map(coord => transform(coord, sourceCrs, targetCrs)); }
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })();
        break;
      case 'MultiLineString':
        transformedCoordinates = (() => {
          try { return geometry.coordinates.map(line => line.map(coord => transform(coord, sourceCrs, targetCrs)));}
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })();
        break;
      case 'Polygon':
        transformedCoordinates = (() => {
          try { return geometry.coordinates.map(ring => ring.map(coord => transform(coord, sourceCrs, targetCrs))); }
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })();
        break;
      case 'MultiPolygon':
        transformedCoordinates = (() => {
          try {  return geometry.coordinates.map(polygon => polygon.map(ring => ring.map(coord => transform(coord, sourceCrs, targetCrs)))); }
          catch (error) { console.error(`error transforming ${geometry.type} coordinates`, error); }
        })()
        break;
      default:
        console.warn(`Unsupported geometry type: ${geometry.type}`);
        transformedCoordinates = geometry.coordinates;
    }
  
    return {
      ...feature,
      geometry: {
        ...geometry,
        coordinates: transformedCoordinates,
      },
    };
};